import { memo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { debounce } from 'lodash';
import SearchIcon from '@material-ui/icons/Search';
import Input from '../../../../Input';

const TripsFreeTextFilter = ({ onSearch }) => {
  const { tripsSearch } = useSelector((store) => store.trip);
  const [value, setValue] = useState(tripsSearch.filterObj.freeText || '');

  const debouncedSave = useRef(debounce((searchObj) => onSearch(searchObj), 500)).current;

  const handleChange = (event) => {
    const { value: newVal } = event.target;
    setValue(newVal);
    const searchObj = {
      ...tripsSearch.searchObj,
      page: 1,
      freeText: newVal,
    };
    debouncedSave(searchObj);
  };

  return (
    <div className="flex items-center justify-between px-3 py-3 rounded-2xl bg-gray-600 bg-opacity-10 focus:outline-none w-full text-gray-600">
      <Input
        type="text"
        placeholder="Search by trip"
        onChange={handleChange}
        value={value}
        className="bg-transparent placeholder-gray-600 w-full focus:outline-none"
      />
      <SearchIcon color="inherit" />
    </div>
  );
};

TripsFreeTextFilter.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

export default memo(TripsFreeTextFilter);
